import { useEffect } from 'react'

import { IonList } from '@ionic/react'
import { useParams } from 'react-router'

// Components
import CompetitorProfileCard from '../root/CompetitorProfileCard'
import EventsProfileListing from '../root/EventsProfileListing'
import WrapperContainer from '../../../components/common/wrappers/WrapperContainer'
import OrganizerProfileCard from '../../../components/organizerSideProfileCard/OrganizerProfileCard'

import FirestoreService from '../../../services/firestoreService'

import { getConvertedData } from '../../../models/interface.helper'

// Redux
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import {
  selectVisitedUserDetailsR,
  selectVisitedUserProfileDetailsR,
  setVisitedUserDetailsAc,
  setVisitedUserProfileDetailsAc,
} from '../../../store/profilePage/profilePageSlice'
import { selectProfileData } from '../../../store/user/userSlice'

import { UserPublicModel } from '../../../models/users-public/users-public.model'
import { UserModel } from '../../../models/users/user.model'

import { IUserPublicInterface } from '../../../models/users-public/users-public.interface'

import { CONST } from '../../../const/const'
const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

// Types
type ProfilePageWrapperProps = {
  handleModal: (showHide: boolean, typeOfModal: string, data?: Object) => void
}

const ProfilePageWrapper = ({ handleModal }: ProfilePageWrapperProps) => {
  // Hooks and vars
  const { userId } = useParams<{ userId: string }>()

  const dispatch = useAppDispatch()

  const visitedUserDetails = useAppSelector(selectVisitedUserDetailsR)
  const profileData = useAppSelector(selectProfileData)
  const visitedUserProfileDetailsR = useAppSelector(selectVisitedUserProfileDetailsR)

  useEffect(() => {
    if (userId) getUserDetails(userId).then()

    return () => {
      dispatch(setVisitedUserProfileDetailsAc(null))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, profileData?.id])

  useEffect(() => {
    if ((!profileData && !visitedUserProfileDetailsR) || (userId && !visitedUserProfileDetailsR))
      return

    let isMyProfile = false
    let profileDetails: IUserPublicInterface | null = null
    let isOrganizerProfileView = false

    if (
      visitedUserProfileDetailsR?.userType === CONST.USE_MODE.ORGANIZER ||
      profileData?.userType === CONST.USE_MODE.ORGANIZER
    ) {
      isOrganizerProfileView = true
    }

    if (visitedUserProfileDetailsR?.id === profileData.id || profileData.id === userId || !userId) {
      isMyProfile = true
    }

    if (visitedUserProfileDetailsR?.id) {
      profileDetails = visitedUserProfileDetailsR
    } else if (profileData?.id) {
      profileDetails = new UserPublicModel({ ...new UserPublicModel(), ...profileData }).toObject()
    }
    if (profileDetails) {
      dispatch(
        setVisitedUserDetailsAc({
          isMyProfile,
          isOrganizerProfileView,
          profileDetails,
        })
      )
    } else dispatch(setVisitedUserDetailsAc(null))

    return () => {
      dispatch(setVisitedUserDetailsAc(null))
    }
  }, [profileData, visitedUserProfileDetailsR, userId])

  // Functions
  async function getUserDetails(id: string) {
    let users
    if (profileData?.id) {
      const usersSnaps = await FirestoreService.getItem(COLLECTIONS.USERS.NAME, id)
      users = UserModel.fromFirestoreDoc(usersSnaps).toObject()
    } else {
      const usersPublicSnaps = await FirestoreService.getItem(COLLECTIONS.USERS_PUBLIC.NAME, id)
      users = UserPublicModel.fromFirestoreDoc(usersPublicSnaps).toObject()
    }
    dispatch(setVisitedUserProfileDetailsAc(getConvertedData(users)))
  }

  return (
    <WrapperContainer
      title="Profile"
      noBg={true}
      removeShadow={true}
      removePadding={true}
      hideTitle={false}
    >
      <div className="flex lg:flex-row flex-col gap-6 flex-1">
        <IonList className="home_root_ion_list lg:max-w-[435px]">
          {visitedUserDetails?.isOrganizerProfileView ? (
            <OrganizerProfileCard
              isMyProfile={!!visitedUserDetails?.isMyProfile}
              handleModal={handleModal}
            />
          ) : (
            <CompetitorProfileCard isMyProfile={!!visitedUserDetails?.isMyProfile} />
          )}
        </IonList>
        <IonList className="home_root_ion_list flex flex-col flex-1 overflow-x-auto">
          <EventsProfileListing />
        </IonList>
      </div>
    </WrapperContainer>
  )
}

export default ProfilePageWrapper
